export const fieldMapping = {
  'Coupon Transaction': [
    'id',
    'createdDateTime',
    'transactionType',
    'transactionResult',
    'clientRequestReference',
    'smartsCouponTransactionReference',
    'couponTransactionReversal',
    'reversalCouponTransaction',
    'partnerId',
    'storeId',
    'storeName',
    'storeRetailerRef',
    'deviceId',
    'deviceName',
    'operatorId',
    'ecrBasketId',
    'totalDiscountAmount',
    'currency',
    'errorCode',
    'errorMessage'

  ],
  'Coupon Scheme': [
    'couponScheme.id',
    'couponScheme.schemeName',
    'couponScheme.schemeType',
    'couponScheme.schemeStatus',
    'couponScheme.creationStartDateTime',
    'couponScheme.creationEndDateTime',
    'couponScheme.redemptionEndDateTime',
    'couponScheme.defaultDurationDays',
    'couponScheme.discountValue',
    'couponScheme.usageLimitPerCoupon',
    'couponScheme.maxCouponsToGenerate',
    'couponScheme.sponsor',
    'couponScheme.discountArticleEan',
    'couponScheme.discountArticleSkuCode',
    'couponScheme.managedBy',
  ],
  'Coupon Token': [
    'couponToken.id',
    'couponToken.status',
    'couponToken.dateIssued',
    'couponToken.dateExpires',
    'couponToken.usageCount',
    'couponToken.usageLimit',
    'couponToken.lastRedeemedOn',
    'couponToken.assignedTo',
    'couponToken.managedBy',
  ]
}
